import { IConfigState } from "../../common/constants/app.dto";

export const configState: IConfigState = {
    grades: [],
    universities: [],
    areas: [],
    sectors: [],
    professions: [],
    positions: [],
    benefits: [],
    geoDepartments: [],
} 

export type ConfigAttrNameState = keyof typeof configState;